module.exports = __webpack_public_path__ + "static/media/bn-mockup-4.9d0a080b.jpg";